// extracted by mini-css-extract-plugin
export default {"infoBox":"InfoBox_infoBox__cWnYR","messageIn":"InfoBox_messageIn__gpaNv","infoSign":"InfoBox_infoSign__TcYDy"};